var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUploadTransactions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:rgb(117, 130, 138);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,4.1C11.6,2.2,9.9,1,8,1S4.4,2.2,3.7,4.1C1.6,4.4,0,6.3,0,8.5c0,2.3,1.8,4.2,4,4.5c0.3,0,0.5-0.2,0.5-0.5 S4.3,12,4,12c-1.7-0.2-3-1.7-3-3.5C1,6.6,2.6,5,4.5,5c0,0,0,0,0,0C4.8,3.3,6.3,2,8,2s3.2,1.3,3.5,3c0,0,0,0,0,0 C13.4,5,15,6.6,15,8.5c0,1.8-1.3,3.2-3,3.5c-0.3,0-0.5,0.3-0.5,0.5S11.7,13,12,13c2.3-0.2,4-2.2,4-4.5C16,6.3,14.4,4.4,12.3,4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,9.5c0-0.1-0.1-0.3-0.2-0.4l-3.5-3C8.1,6,7.9,6,7.7,6.1l-3.5,3C4.1,9.2,4,9.4,4,9.5C4,9.8,4.2,10,4.5,10 c0.1,0,0.2,0,0.3-0.1l2.7-2.3v6.9C7.5,14.8,7.7,15,8,15s0.5-0.2,0.5-0.5V7.6l2.7,2.3c0.1,0.1,0.2,0.1,0.3,0.1 C11.8,10,12,9.8,12,9.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadTransactions);
export default __webpack_public_path__ + "static/media/IconUploadTransactions.9458a025688570f7d913ab05babbf3aa.svg";
export { ForwardRef as ReactComponent };